// PaginationDots.js
import React from 'react';
import { useStylesModalOffer } from './hooks/useStyles';

const PaginationDots = ({
  totalPages,
  currentPage,
  onPageChange,
}: {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}) => {
  const { classes } = useStylesModalOffer();
  const dots = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < totalPages; i++) {
    dots.push(
      <div
        key={i}
        className={i === currentPage ? classes.dotActive : classes.dot}
        onClick={() => onPageChange(i)}
      />
    );
  }

  return <div className={classes.paginationsDots}>{dots}</div>;
};

export default PaginationDots;
